const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  create ({ state, commit, rootState }, params) {
    return rootState.axios.post('/coin/v1frontend/lucky-draw/create', params)
  },
  searchWinners ({ state, commit, rootState }, params) {
    return rootState.axios.get('/coin/v1frontend/lucky-draw/search-winners', { params })
  },
  myPrizes ({ state, commit, rootState }, params) {
    return rootState.axios.get('/coin/v1frontend/lucky-draw/my-prizes', { params })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
